// extracted by mini-css-extract-plugin
module.exports = {"new":"view-default_new_2gdfP","dangerous":"view-default_dangerous_26k7Z"};